/* Funzione per convertire orario e data in baso al linguaggio scelto */
function convertData(date,locale){
    var loc = ""
    var time = new Date(date);
    switch (`${locale}`) {
        case 'en' :
            loc = 'en'
            
            break;
        case 'it':
            loc = 'it'
            
            break;

            case 'fr':
                loc = 'fr'
                
                break;
        default:
            
            loc = 'it'
    }
     return  (date === undefined ) ? "" : time.toLocaleDateString(loc)
  }

  export default (convertData)